import palette from '../palette';

export default {
  active: {
    color: `${palette.success.main} !important`,
  },
  completed: {
    color: `${palette.success.main} !important`,
  },
};